module.exports = __webpack_public_path__ + "static/media/illustration-woman-desktop.44e30650.svg";